import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Button } from "../../components/primitives/Button";
import { Input } from "../../components/primitives/Input";
import { Label } from "../../components/primitives/Label";
import { Icon } from "../../components/primitives/Icon";
import { AppLogo } from "../../components/brand/AppLogo";
import { t } from "../../i18n";
export function Login({ onEmailLogin, error, busy }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const emailRef = useRef(null);
    useEffect(() => {
        emailRef.current?.focus();
    }, []);
    function submitEmail() {
        if (busy || !email || !password)
            return;
        void onEmailLogin({ email, password });
    }
    return (_jsx("div", { style: {
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "var(--bg)",
            padding: 24,
        }, children: _jsxs("div", { className: "surface shadow-warm", style: { width: "100%", maxWidth: 420, padding: 28 }, children: [_jsxs("div", { style: { textAlign: "center", marginBottom: 20 }, children: [_jsx(AppLogo, { size: "lg", subtitle: "Shop operations", className: "justify-center" }), _jsx("p", { style: { fontSize: 13, color: "var(--ink-2)", marginTop: 4 }, children: "Sign in to start your shift" })] }), _jsxs("form", { onSubmit: (e) => {
                        e.preventDefault();
                        submitEmail();
                    }, style: { display: "flex", flexDirection: "column", gap: 12 }, children: [_jsxs("div", { children: [_jsx(Label, { htmlFor: "login-username", children: t("login.username") }), _jsx(Input, { ref: emailRef, id: "login-username", type: "text", autoComplete: "username", value: email, onChange: (e) => setEmail(e.target.value) })] }), _jsxs("div", { children: [_jsx(Label, { htmlFor: "login-password", children: t("login.password") }), _jsx(Input, { id: "login-password", type: "password", autoComplete: "current-password", value: password, onChange: (e) => setPassword(e.target.value) })] }), _jsx(Button, { type: "submit", variant: "accent", size: "lg", className: "w-full", disabled: busy || !email || !password, children: t("login.signIn") })] }), error && (_jsxs("div", { style: {
                        marginTop: 14,
                        padding: "10px 12px",
                        borderRadius: 6,
                        background: "var(--danger-soft)",
                        color: "var(--danger)",
                        fontSize: 12,
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                    }, children: [_jsx(Icon, { name: "circle-alert", size: "sm" }), error] }))] }) }));
}
//# sourceMappingURL=Login.js.map